import { ChakraProvider, theme, extendTheme } from '@chakra-ui/react'

const colors = {
  ...theme.colors,
}
const fontSizes = {
  ...theme.fontSizes,
  xs: '12px',
  sm: '13px',
  md: '14px',
  lg: '15px',
  xl: '16px',
  '2xl': '17px',
  '3xl': '18px',
  '4xl': '19px',
  '5xl': '20px',
  '6xl': '21px',
  '7xl': '22px',
  '8xl': '23px',
  '9xl': '24px',
  '2xs': '11px',
}
const styles = {
  ...theme.styles,
}
const config = {
  ...theme.config,
  initialColorMode: 'light',
  useSystemColorMode: false,
}

const customizeTheme = extendTheme({
  ...theme,
  colors,
  fontSizes,
  styles,
  config,
})

const Providers = ({ children }: any) => (
  <ChakraProvider theme={customizeTheme}>{children}</ChakraProvider>
)

export default Providers
